import { Outlet, useParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import users from 'modules/core/store/collections/users'

import FoldersSettings from 'modules/documents/components/Settings/Folders'
import { useGetFolders } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'

const PublicCompanyFolderIndexPage = () => {
  const { navigation } = useNavigation()

  const { id } = useParams()
  const { loading, folders } = useGetFolders({ ids: [Number(id)] })
  const { company } = useCurrentSession()

  const space = SPACES.COMPANY_PUBLIC
  const folder = folders[0]

  if (loading || !id)
    return (
      <Box width="full" alignItems="center">
        <Spinner />
      </Box>
    )

  if (!folder) return <NotFound />

  return (
    <>
      <Outlet
        context={{
          parentRoute: navigation.settings.folders.public.show.fullPath({ id }),
          space,
          companyId: company.id,
          parentFolderId: folder.id,
          rootParentFolderId: folder.rootParentFolder?.id || folder.id,
        }}
      />

      <FoldersSettings
        space={space}
        folderVariables={{ parentFolderId: folder.id }}
        folder={folder}
        canManage={users.current.policy.can('documents.companyManagePublicCompanyFolders')}
        newFolderRoute={navigation.settings.folders.public.show.new.fullPath({ id })}
      />
    </>
  )
}

export default PublicCompanyFolderIndexPage
